export default "__VITE_ASSET__C25tw3Sc__"